export class Benefit {
    constructor(element) {
        this._element = element;
        this._redeemed = false;
        this.id = this._element.dataset.benefitid;
        this.art = this._element.dataset.benefitart;
        this.detailBox = this._element.querySelector('.benefitDetails');
        this.cancelButton = this._element.querySelector('.cancelButton');
        this.submitButton = this._element.querySelector('.submitButton');
        this.showButton = this._element.querySelector('.showBenefit');

        this.init();
    };

    get redirect() {
        return (this.art == 'tickets' || this.art == 'present' || this.art == 'landingpage') ? true : false;
    };

    init() {
        if (this.showButton) {
            this.showButton.addEventListener('click', event => {
                event.preventDefault();
                this.showDetails();
            })
        }

        if (this.cancelButton) {
            this.cancelButton.addEventListener('click', event => {
                if (!this._redeemed) {
                    event.preventDefault();
                    OVS.app.helper.hide('.benefitDetails');
                }
            });
        }

        if (this.submitButton) {
            this.submitButton.addEventListener('click', event => {
                event.preventDefault();
                this.redeem();
            });
        }
    }

    showDetails() {
        OVS.app.helper.hide('.benefitDetails');
        OVS.app.helper.show(this.detailBox);
        OVS.app.helper.scrollTo('#benefit-' + this.id);
    }

    redeem() {
        const redeemRequest = new Request('POST', '/gutschein/redeem/customer');
        
        redeemRequest.data = {
            customerId : OVS.app.user.customerId,
            benefitId : this.id,
        };

        redeemRequest.call(response => {
            const details = this.detailBox.querySelector('.row');
            const wrapper = document.createElement('div')
            
            wrapper.innerHTML = [
            '<div class="col-12 pt-3">',
            '<div class="alert alert-success d-flex align-items-center" role="alert">',
            '<i class="bi bi-check-circle-fill"></i> ',
            '<div>&nbsp;&nbsp;Gutschein erfolgreich eingelöst</div></div>',
            '</div>'
            ].join('');

            if (response.status == 'ok') {
                this._redeemed = true;
                OVS.app.helper.addClass(this.submitButton, 'disabled');
                details.append(wrapper);
                if (this.redirect && response.data.redirect) {
                    document.location = response.data.redirect;
                }
            }

        }, () => {});
    }
};